import { Component } from 'react';

import CustomLinkButton from "GeneralComponents/CustomLinkButton";
import ComponentImage from "GeneralComponents/ComponentImage";
import BannerItem from "../Banner.interface"
import LimitedContent from "GeneralComponents/LimitedContent";
import { MediaItem } from "Interfaces/general.interface";

/*import "./CombinedBanner.css";*/
import "./MiniBanner.css";



export default class MiniBannerItem extends Component {

    props: any;

    state: BannerItem;



    constructor(props) {
        super(props);

        this.state = {

            index: this.props.bannerItem.index,
            title: this.props.bannerItem.title,
            content: this.props.bannerItem.content,
            url: this.props.bannerItem.url,
            link: this.props.bannerItem.link,
            icon: this.props.bannerItem.icon,
            imageOrMovie: this.props.bannerItem.imageOrMovie as MediaItem,
            mobileImageOrMovie: this.props.bannerItem.mobileImageOrMovie as MediaItem,
            specialTextAlign: this.props.bannerItem.specialTextAlign,
            lightShadowColor: this.props.bannerItem.lightShadowColor,
            noShadow: this.props.bannerItem.noShadow,
            oneSize: false
        };
    }

    render() {



        return (


            <div className={`d-lg-flex flex-row mst-Banner-Content mst-ContentBanner-Content ${this.state.lightShadowColor ? ' lightShadow' : ' darkShadow'} ${this.state.noShadow ? ' noShadow' : ''} ${this.state.specialTextAlign ? ' aliginCenter' : ' '}`}>



                {this.state.imageOrMovie.url && <ComponentImage
                    image={this.state.imageOrMovie}
                    imageClass="img-fluid "
                    mobileImage={this.state.mobileImageOrMovie}
                    mobileImageClass="img-fluid"
                    wrapperDivClass="mst-Banner-Image mst-ContentBanner-Image"
                    cancelVideoLoop={this.props.cancelVideoLoop}
                    onVideoEnded={this.props.onVideoEnded }
                />

                }




                <div className={`my-auto  mst-ContentBanner-Content-Box ${this.state.specialTextAlign ? ' aliginCenter' : ' '} `}>
                    <div id={"carouselContentControls-" + this.state.index} className="outline-none mst-MiniBanner-Content  mst-CombinedBanner-Content">
                        <div className="mst-TextArea">
                            <h2 className={`mst-banner-title ${this.state.specialTextAlign ? ' mx-auto' : ' '} ${this.state.content ? '' : ' mst-titleOnly'}`}>
                                {this.state.title}
                            </h2>
                            <div className="mst-Content">
                                <div className="mst-ContentBanner-Content-Text mst-rich-desc-field content-txt limited-content" dangerouslySetInnerHTML={{ __html: this.state.content }} />
                                {/*<LimitedContent classNames="mst-ContentBanner-Content-Text mst-rich-desc-field content-txt" htmlContent={this.state.Content}></LimitedContent>*/ }
                            </div>
                        </div>
                        {
                            (this.state.url || this.state.link) &&
                            <div className="content-txt  mst-ContentBanner-Content-BtnLink mt-1 mt-lg-3 mb-4 " >

                                <CustomLinkButton
                                    title={this.state.title}
                                    pageUrl={this.state.url}
                                    link={this.state.link}
                                    isBtn={true}
                                    btnClass={"btn mst-btn btn-primary px-auto"}
                                    linkClass={""}
                                    dir={this.props.dir}
                                    linkIcon={true}
                                    charLimit={25}
                                />


                            </div>
                        }


                    </div>

                </div>



            </div>

        );
    }
}
